import api from '@/lib/axios';

export const proveedoresService = {
  async findAll(companyId: string, search?: string) {
    const response = await api.get('/suppliers', { params: { companyId, search } });
    return response.data;
  },

  async findById(id: string) {
    const response = await api.get(`/suppliers/${id}`);
    return response.data;
  },

  async create(data: { companyId: string; name: string; contactName?: string; phone?: string; email?: string; rfc?: string; address?: string; paymentTerms?: string }) {
    const response = await api.post('/suppliers', data);
    return response.data;
  },

  async update(id: string, data: any) {
    const response = await api.patch(`/suppliers/${id}`, data);
    return response.data;
  },

  async deactivate(id: string) {
    const response = await api.delete(`/suppliers/${id}`);
    return response.data;
  },

  async bulkCreate(items: any[]) {
    const response = await api.post('/suppliers/bulk', { items });
    return response.data;
  },
};
